import { ThemeProvider } from '@mui/material/styles';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@/contexts/auth0Provider/AuthContext';

import App from './App';
import ToastContextProvider from './components/ui/Toast/ToastContextProvider';
import customTheme from './themes/muiTheme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider theme={customTheme}>
          <ToastContextProvider>
            <App env="standalone" />
          </ToastContextProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
